// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bii_j bii_i bii_bc bii_r bii_st","QualityCheckboxes__quality":"ex_b"};